import React from 'react';
import { filterDataProps } from '@THC/utils/helpers';
import { ErrorIcon } from '../../Icons/Error';
import { InfoIcon } from '../../Icons/Info';
import { WarningIcon } from '../../Icons/Warning';
export const resolveAdditionalInputComponent = ({ item: Item, size }) => typeof Item === 'string' ? Item : <Item size={size === 'medium' ? 'small' : 'medium'}/>;
export const nonHTMLInputProps = [
    '__internal',
    'as',
    'append',
    'formProps',
    'fullHeight',
    'fullWidth',
    'intent',
    'label',
    'prepend',
    'selectIcon',
    'showLabel',
    'showSeparator',
    'size',
    'validationMessage',
    'withRef',
];
export const prepareUseInputProps = (props, disabled) => {
    const rootProps = filterDataProps(props);
    const rootPropsKeys = Object.keys(rootProps);
    const asProps = Object.keys(props)
        .filter((p) => !rootPropsKeys.includes(p.toString()) && !nonHTMLInputProps.includes(p.toString()))
        .reduce((acc, n) => ({ ...acc, [n]: props[n] }), {});
    return {
        additionalsProps: {
            'aria-hidden': true,
            showSeparator: props.showSeparator,
            size: props.size,
        },
        asProps,
        labelProps: {
            htmlFor: props.id,
        },
        rootProps,
        wrapperProps: {
            'aria-disabled': disabled,
        },
    };
};
export const resolveValidationIcon = (intent) => {
    switch (intent) {
        case 'error':
            return ErrorIcon;
        case 'warning':
            return WarningIcon;
        default:
            return InfoIcon;
    }
};
export const resolveValidationSize = (size) => {
    switch (size) {
        case 'large':
            return 'small--regular';
        default:
            return 'xsmall--small';
    }
};
